import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const nudgeCard = style([
  {
    display: 'flex',
    justifyContent: 'space-between',
    gap: space.s16,
    backgroundColor: themeVars.container.prominent.background.idle,
    padding: space.s24,
    paddingBottom: 0,
    overflow: 'hidden',
    paddingRight: 0,
    borderRadius: borderRadius.r12,
    border: `1px solid ${themeVars.color.surface.brand.active}`,
    marginBottom: space.s16,
  },
]);

export const nudgeLeftContainer = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s16,
  paddingBottom: space.s24,
});

export const nudgeTitle = style([
  typography.titleMd,
  {
    marginBottom: space.s8,
  },
]);

export const nudgeDescription = style([typography.bodyMd]);

export const nudgeExploreButton = style([
  {
    width: 'fit-content',
    minWidth: 150,
  },
]);

export const nudgeImageContainer = style([
  {
    position: 'relative',
    height: 'fit-content',
    alignSelf: 'flex-start',
    width: 450,
  },
  responsiveStyle({
    mobile: {
      maxWidth: 110,
    },
    tablet: {
      maxWidth: 350,
    },
    laptop: {
      maxWidth: 400,
    },
    desktop: {
      maxWidth: 450,
    },
  }),
]);
export const nudgeImage = style([
  {
    position: 'absolute',
    borderTopLeftRadius: borderRadius.r12,
    right: 0,
    top: 0,
    left: 0,
    width: 450,
  },
]);
